import Authenticated from 'components/Authenticated';
import AccentSidebarLayout from 'layouts/AccentSidebarLayout';
import BaseLayout from 'layouts/BaseLayout';
import DocsLayout from 'layouts/DocsLayout';
import { RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import accessControlRoutes from './accessControl';
import accountRoutes from './account';
import applicationsRoutes from './applications';
import baseRoutes from './base';
import blocksRoutes from './blocks';
import dashboardsRoutes from './dashboards';
import documentationRoutes from './documentation';
import fileRoutes from './file';
import financialRoutes from './financial';
import managementRoutes from './management';
import serviceRoutes from './services';
import ticketRoutes from './ticket';

const router: RouteObject[] = [
  {
    path: 'account',
    children: accountRoutes,
  },
  {
    path: '',
    element: <BaseLayout />,
    children: baseRoutes,
  },

  // Documentation

  {
    path: 'docs',
    element: <DocsLayout />,
    children: documentationRoutes,
  },

  // Extended Sidebar Layout

  {
    path: 'accent-sidebar',
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="dashboards" replace />,
      },
      {
        path: 'dashboards',
        children: dashboardsRoutes,
      },
      {
        path: 'blocks',
        children: blocksRoutes,
      },
      {
        path: 'applications',
        children: applicationsRoutes,
      },
      {
        path: 'management',
        children: managementRoutes,
      },
      {
        path: 'services',
        children: serviceRoutes,
      },
      {
        path: 'access-control',
        children: accessControlRoutes,
      },
      {
        path: 'file',
        children: fileRoutes,
      },
      {
        path: 'financial',
        children: financialRoutes,
      },
    ],
  },

  // Tickets

  {
    path: 'tickets',
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: ticketRoutes,
  },

  // {
  //   path: 'extended-sidebar',
  //   element: (
  //     <Authenticated>
  //       <ExtendedSidebarLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     },
  //     {
  //       path: 'register',
  //       children: registerRoutes
  //     },
  //     {
  //       path: 'files',
  //       children: filesRoutes
  //     }
  //   ]
  // }

  // Boxed Sidebar Layout

  // {
  //   path: 'boxed-sidebar',
  //   element: (
  //     <Authenticated>
  //       <BoxedSidebarLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },

  // // Accent Sidebar Layout

  // {
  //   path: 'accent-sidebar',
  //   element: (
  //     <Authenticated>
  //       <AccentSidebarLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },

  // // Collapsed Sidebar Layout

  // {
  //   path: 'collapsed-sidebar',
  //   element: (
  //     <Authenticated>
  //       <CollapsedSidebarLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },

  // // Bottom Navigation Layout

  // {
  //   path: 'bottom-navigation',
  //   element: (
  //     <Authenticated>
  //       <BottomNavigationLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },

  // // Top Navigation Layout

  // {
  //   path: 'top-navigation',
  //   element: (
  //     <Authenticated>
  //       <TopNavigationLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },

  // // Accent Header Layout

  // {
  //   path: 'accent-header',
  //   element: (
  //     <Authenticated>
  //       <AccentHeaderLayout />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="dashboards" replace />
  //     },
  //     {
  //       path: 'dashboards',
  //       children: dashboardsRoutes
  //     },
  //     {
  //       path: 'blocks',
  //       children: blocksRoutes
  //     },
  //     {
  //       path: 'applications',
  //       children: applicationsRoutes
  //     },
  //     {
  //       path: 'management',
  //       children: managementRoutes
  //     }
  //   ]
  // },
];

export default router;
